var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("p", { staticClass: "menu-label" }, [
          _c("span", { staticClass: "title is-6" }, [_vm._v(" Filters ")]),
          _c(
            "button",
            {
              staticClass: "button is-pulled-right is-small is-turquoise",
              on: { click: _vm.gotoV1 },
            },
            [
              _c("span", { staticClass: "icon" }, [
                _c("i", { staticClass: "mdi mdi-arrow-right" }),
              ]),
              _c("span", [_vm._v("V1")]),
            ]
          ),
        ]),
        _c("ul", { staticClass: "menu-list" }, [
          _c("li", [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.innerValue.invoiceNo,
                      expression: "innerValue.invoiceNo",
                    },
                  ],
                  staticClass: "input is-capitalized",
                  attrs: { type: "text", placeholder: "Invoice No" },
                  domProps: { value: _vm.innerValue.invoiceNo },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.innerValue, "invoiceNo", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.innerValue.debtorName,
                      expression: "innerValue.debtorName",
                    },
                  ],
                  staticClass: "input is-capitalized",
                  attrs: { type: "text", placeholder: "Debtor Name" },
                  domProps: { value: _vm.innerValue.debtorName },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.innerValue,
                        "debtorName",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.innerValue.quoteNo,
                      expression: "innerValue.quoteNo",
                    },
                  ],
                  staticClass: "input is-capitalized",
                  attrs: { type: "text", placeholder: "Quote No" },
                  domProps: { value: _vm.innerValue.quoteNo },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.innerValue, "quoteNo", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("v-date-picker", {
                  attrs: {
                    "is-dark": _vm.$theme.isDark,
                    masks: _vm.formats,
                    attributes: _vm.attrs,
                    locale: _vm.$userInfo.locale,
                    "model-config": { timeAdjust: "00:00:00" },
                    timezone: _vm.$filters.getIanaTimezone(),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ inputValue, inputEvents }) {
                        return [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "div",
                              { staticClass: "control has-icons-left" },
                              [
                                _c(
                                  "input",
                                  _vm._g(
                                    {
                                      staticClass: "input",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Date From...",
                                      },
                                      domProps: { value: inputValue },
                                    },
                                    inputEvents
                                  )
                                ),
                                _c(
                                  "span",
                                  { staticClass: "icon is-small is-left" },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-calendar mdi-18px",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedFromDate,
                    callback: function ($$v) {
                      _vm.selectedFromDate = $$v
                    },
                    expression: "selectedFromDate",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("v-date-picker", {
                  attrs: {
                    "is-dark": _vm.$theme.isDark,
                    masks: _vm.formats,
                    attributes: _vm.attrs,
                    locale: _vm.$userInfo.locale,
                    "model-config": { timeAdjust: "23:59:59" },
                    timezone: _vm.$filters.getIanaTimezone(),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ inputValue, inputEvents }) {
                        return [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "div",
                              { staticClass: "control has-icons-left" },
                              [
                                _c(
                                  "input",
                                  _vm._g(
                                    {
                                      staticClass: "input",
                                      attrs: {
                                        type: "text",
                                        placeholder: "Date To...",
                                      },
                                      domProps: { value: inputValue },
                                    },
                                    inputEvents
                                  )
                                ),
                                _c(
                                  "span",
                                  { staticClass: "icon is-small is-left" },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-calendar mdi-18px",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedToDate,
                    callback: function ($$v) {
                      _vm.selectedToDate = $$v
                    },
                    expression: "selectedToDate",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _c("hr"),
        _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: { click: _vm.onFilterClick },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
                ]),
                _c("span", [_vm._v("Filter")]),
              ]
            ),
          ]),
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.onResetClick } },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
                ]),
                _c("span", [_vm._v("Reset")]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }